import { QuestionInsightCard } from './QuestionInsightCard'
import {
  QuestionsGrid,
  EmptyState,
  EmptyStateTitle,
  EmptyStateText,
} from '../../pages/SurveyInsightsPageStyles'
import type { ReconciledQuestion } from '../../pages/surveyInsightsUtils'

export interface AllResponsesTabProps {
  reconciledQuestions: ReconciledQuestion[]
  responseCount: number
  isPrinting: boolean
}

export function AllResponsesTab({
  reconciledQuestions,
  responseCount,
  isPrinting,
}: AllResponsesTabProps) {
  if (responseCount === 0) {
    return (
      <QuestionsGrid>
        <EmptyState>
          <EmptyStateTitle>No responses yet</EmptyStateTitle>
          <EmptyStateText>Share the survey link to start collecting feedback.</EmptyStateText>
        </EmptyState>
      </QuestionsGrid>
    )
  }

  return (
    <QuestionsGrid>
      {reconciledQuestions.map((question, i) => (
        <QuestionInsightCard
          key={question.id ?? i}
          question={question}
          questionIndex={i}
          answers={question.answers}
          isPrinting={isPrinting}
          isDeleted={question.isDeleted}
        />
      ))}
    </QuestionsGrid>
  )
}
